import {loading, stopLoading} from "../../helpers/loading";
import {getSingleInputByNameV3} from "../../helpers/forms/formInputsHelpers";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";

function initPublicAuditionHeadshotIndex() {

	// Setup submit button
	const submitButton = document.querySelector('.continue-button')
	submitButton.addEventListener('click', handleContinueRequest)

	const previewContainer = document.querySelector('.preview-container');

	const uploaderContainer = document.querySelector('.upload-container');

	const downloadPreviewRoute = getSingleInputByNameV3(document.body, 'download_preview_route');

	const removeImageButton = document.querySelector('.remove-image-button');

	if (removeImageButton) {
		removeImageButton.addEventListener('click', removeImage);
	}

	setInterval(updateDom, 16)

	/** Methods */

	function handleContinueRequest() {
		loading();

		Axios.post(submitButton.dataset.route, {
			mediaUUID: submitButton.dataset.imageUUID,
		})
			.then(response => {
				setTimeout(() => {
					// Show loading again
					loading();

					// Redirect to next step
					// noinspection JSUnresolvedReference
					window.location.href = response.data.redirectUrl;
				})
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	function removeImage() {
		const removeButtonFromUploader = document.querySelector('.media-library-text-link[dusk="remove"]')
		if (removeButtonFromUploader) {
			removeButtonFromUploader.click();
		}

		// Remove pre seeded flag, if any
		uploaderContainer.classList.remove('pre-seeded')
	}

	function updateDom() {
		const photoWrapper = previewContainer.querySelector('.photo-wrapper');

		const thumbplaceHolder = uploaderContainer.querySelector('.media-library-thumb');

		if (thumbplaceHolder) {
			const imageUUIDInput = uploaderContainer.querySelector('input[data-uuid]');

			// An image was just uploaded
			if (imageUUIDInput && imageUUIDInput.value) {
				// Check if we have not updated it already
				// And if an img already exists, ignore if it was one loaded from the server
				if (photoWrapper.querySelector('img') && uploaderContainer.classList.contains('pre-seeded') === false) {
					// Preview already updated
					return;
				}

				// Update preview
				const downloadRoute = downloadPreviewRoute.replace('_UUID_', imageUUIDInput.value)

				photoWrapper.innerHTML = `
					<img src="${downloadRoute}" alt="">
				`;

				// Display remove button
				removeImageButton.classList.remove('pointer-events-none');
				removeImageButton.classList.remove('opacity-0');

				// Hide uploader
				// uploaderContainer.classList.add('pointer-events-none');
				// uploaderContainer.classList.add('opacity-0');

				// Update continue button
				submitButton.innerHTML = 'Continue'
				submitButton.dataset.imageUUID = imageUUIDInput.value;

				// Remove pre seeded flag, if any
				uploaderContainer.classList.remove('pre-seeded')
			}
		} else {
			// Image was removed, update dom
			if (photoWrapper.querySelector('.no-photo-message')) {
				// Already updated...
				return;
			}

			// An image already exists from page load, leave it alone
			if (uploaderContainer.classList.contains('pre-seeded')) {
				return;
			}

			photoWrapper.innerHTML = `
				<div class="no-photo-message text-muted text-monospace text-uppercase">
					No Image Uploaded
				</div>
			`;

			// Hide remove button
			removeImageButton.classList.add('opacity-0');
			removeImageButton.classList.add('pointer-events-none');

			// Show uploader
			// uploaderContainer.classList.remove('pointer-events-none');
			// uploaderContainer.classList.remove('opacity-0');

			// Update continue button
			submitButton.innerHTML = 'Skip';
			submitButton.dataset.imageUUID = '';
		}
	}
}

export {
	initPublicAuditionHeadshotIndex
}
